import React from 'react';
import { withStyles, WithStyles } from '@mui/styles';
import { ShippingStyles } from './shipping.styles';
import { IPrintLabelButton } from './types';
import VoidPickupButton from './void-pickup-button';
import PickupButton from './pickup-button';
import { showReadyForPickupButton, showVoidPickupButton } from './utils';

interface IShippingProps extends IPrintLabelButton, WithStyles<typeof ShippingStyles> {}

const PickupShippingButtons = (props: IShippingProps): JSX.Element | null => {
  const {
    orderId,
    currentPrintInformation,
    currentDeliveryInformation,
    currentFdcInformation,
    disabled,
    pharmacyInfo,
    updateShippingPage = () => {},
  } = props;

  const allowReadyForPickupButton = showReadyForPickupButton(
    pharmacyInfo?.workflow_type,
    currentFdcInformation?.statusId,
    currentDeliveryInformation?.deliveryMethod,
  );

  const allowVoidPickupButton = showVoidPickupButton(
    pharmacyInfo?.workflow_type,
    currentFdcInformation?.statusId,
    currentDeliveryInformation?.deliveryMethod,
  );

  const displayPickUpButtonsGroup = (): JSX.Element | null => {
    const showVoidButton = !allowReadyForPickupButton && allowVoidPickupButton;
    if (allowReadyForPickupButton) {
      return (
        <PickupButton
          currentDeliveryInformation={currentDeliveryInformation}
          currentPrintInformation={currentPrintInformation}
          currentFdcInformation={currentFdcInformation}
          orderId={orderId}
          disabled={disabled}
          updateShippingPage={updateShippingPage}
        />
      );
    }
    if (showVoidButton) {
      return (
        <VoidPickupButton
          currentDeliveryInformation={currentDeliveryInformation}
          currentPrintInformation={currentPrintInformation}
          currentFdcInformation={currentFdcInformation}
          orderId={orderId}
          updateShippingPage={updateShippingPage}
        />
      );
    }
    return null;
  };

  return displayPickUpButtonsGroup();
};

export default withStyles(ShippingStyles)(PickupShippingButtons);
